import React from "react";
import styles from "./styles.m.css";
import { Icon } from "../../atoms/icon";

const StoryPremiumCard = () => (
  <div className={styles["pending-premium"]}>
    <span className={styles["premium-count"]}>
      <Icon type="premium" />
    </span>
    <span className={`${styles["premium-name"]} hidden-mobile`}>பிரீமியம் ஸ்டோரி</span>
  </div>
);

export default StoryPremiumCard;
